import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const ClockDashkIcon: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.70166 5.20181C8.97779 5.20181 9.20166 5.42567 9.20166 5.70181V8.16453L11.0857 9.29033C11.3228 9.43199 11.4001 9.73899 11.2585 9.97599C11.1168 10.2131 10.8098 10.2904 10.5728 10.1487L8.44519 8.87739C8.29419 8.78713 8.20166 8.62413 8.20166 8.44819V5.70181C8.20166 5.42567 8.42553 5.20181 8.70166 5.20181Z"
        fill={props.fill || "currentColor" || "white"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.15038 1.89296C7.38717 2.03503 7.46397 2.34216 7.3219 2.57895L7.31797 2.58544C7.1759 2.82222 6.86878 2.89901 6.63199 2.75693C6.3952 2.61486 6.31842 2.30773 6.46049 2.07094L6.46438 2.06445C6.60646 1.82766 6.91358 1.75088 7.15038 1.89296Z"
        fill={props.fill || "currentColor" || "white"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.60692 3.62602C4.84371 3.76809 4.92049 4.07522 4.77842 4.31201L4.77453 4.3185C4.63245 4.55529 4.32532 4.63207 4.08853 4.48999C3.85174 4.34792 3.77496 4.04079 3.91703 3.804L3.92093 3.79751C4.063 3.56073 4.37013 3.48394 4.60692 3.62602Z"
        fill={props.fill || "currentColor" || "white"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.24217 6.39033C3.47896 6.5324 3.55574 6.83952 3.41367 7.07632L3.40978 7.08279C3.2677 7.31959 2.96058 7.39639 2.72378 7.25432C2.487 7.11226 2.41021 6.80512 2.55228 6.56832L2.55618 6.56183C2.69825 6.32504 3.00538 6.24826 3.24217 6.39033Z"
        fill={props.fill || "currentColor" || "white"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.40428 9.43593C3.64107 9.578 3.71786 9.88513 3.57578 10.1219L3.57189 10.1284C3.42981 10.3652 3.12268 10.4419 2.88589 10.2999C2.6491 10.1578 2.57232 9.85066 2.7144 9.61386L2.71829 9.6074C2.86036 9.3706 3.16749 9.29386 3.40428 9.43593Z"
        fill={props.fill || "currentColor" || "white"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.08403 11.9773C5.31379 12.1305 5.37588 12.4409 5.22271 12.6706L5.21881 12.6765C5.06563 12.9063 4.7552 12.9683 4.52543 12.8151C4.29567 12.662 4.23359 12.3515 4.38676 12.1218L4.39065 12.1159C4.54383 11.8862 4.85427 11.8241 5.08403 11.9773Z"
        fill={props.fill || "currentColor" || "white"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.39304 1.99931C8.39344 1.72317 8.61757 1.49962 8.8937 1.5C12.4838 1.50492 15.3895 4.41907 15.3846 8.00913C15.3797 11.5993 12.4655 14.5049 8.8755 14.5C8.0567 14.4986 7.27197 14.3463 6.54925 14.0676C6.2916 13.9683 6.16327 13.6789 6.26262 13.4212C6.36196 13.1635 6.65137 13.0352 6.90902 13.1345C7.51864 13.3696 8.18177 13.4988 8.87684 13.5C11.9147 13.5041 14.3804 11.0455 14.3846 8.00773C14.3888 4.96989 11.9301 2.50416 8.89237 2.5C8.61617 2.49962 8.39264 2.27546 8.39304 1.99931Z"
        fill={props.fill || "currentColor" || "white"}
      />
    </svg>
  );
};

export default ClockDashkIcon;
